import { API_BASE_URL } from "../../constants"
import SoundFile from "../../types/SoundFile"
import axios from "../axios"

export default function importFreesound(
  freesoundId: string
): Promise<SoundFile> {
  return axios
    .post(`${API_BASE_URL}/freesounds/import`, { freesoundId })
    .then((response) => response.data)
}
